module.exports = __webpack_public_path__ + "static/media/mastercard.b34381c4.svg";